/**
 * Convert keys of the baseObject to upper or lower case and remove all
 * non alphabetic characters
 * @param baseObject original object
 * @param toCase case to convert keys to, possible values "upper" or "lower"
 */
export const getKeyModifiedObject = (baseObject: Object, toCase: String) => {
  const convertedObject = {}
  baseObject &&
    Object.keys(baseObject).forEach((objKey) => {
      switch (toCase) {
        case 'lower':
          convertedObject[objKey.toLowerCase().replace(/[^a-zA-Z]+/g, '')] =
            baseObject[objKey]
          break
        case 'upper':
          convertedObject[objKey.toUpperCase().replace(/[^a-zA-Z]+/g, '')] =
            baseObject[objKey]
          break
        default:
          convertedObject[objKey] = baseObject[objKey]
          break
      }
    })

  return convertedObject
}

export default getKeyModifiedObject
